module.exports = __webpack_public_path__ + "img/actions.2a77885c.svg";